import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {Table, Button, Modal, Switch, Tag} from 'antd'
import { QuestionCircleFilled, DeleteOutlined, CheckCircleOutlined, CloseCircleOutlined, ClockCircleOutlined, } from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
const storage = window.localStorage
const {confirm} = Modal

@inject('marketingSmsSignatureStore', 'accountStore')
@observer
class SearchResult extends Component {
  state = {
  }

  componentDidMount() {
  }
  handleDel = (record) => {
    const {marketingSmsSignatureStore,t} = this.props
    confirm({
      title: t(`general.deleteData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.sureToDelete`),
      okText: t(`general.delete`),
      cancelText: t(`general.cancel`),
      onOk() {
        marketingSmsSignatureStore.onDeleteJobAction(record?.id)
      },
      onCancel() {
      },
    })
    return false
  }
  onChangeDefault = (e, record) => {
    const {marketingSmsSignatureStore} = this.props
    marketingSmsSignatureStore.onDefaultJobAction({
      id: record?.id,
      isDefault: e ? 0 : 1
    })
  }
  handlePageChange = (page, pageSize) => {
    const {marketingSmsSignatureStore} = this.props
    marketingSmsSignatureStore.onChangePageNumAction(page, pageSize)
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  render() {
    const {marketingSmsSignatureStore, accountStore, t} = this.props
    const {pageNo, pageSize, itemCount, jobList, statusList} = marketingSmsSignatureStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange)
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    const isPowerUser = accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser || false
    return (
      <>
        <Table className="searchResult" dataSource={toJS(jobList)} pagination={pagination} rowKey="id" rowClassName={this.getRowClassName} scroll={{x: '110%'}} bordered>
          <Table.Column title={t(`marketingManagement.groupName`)} dataIndex="marketingGroupName" key="marketingGroupName" ellipsis={true} />
          <Table.Column title={t(`marketingManagement.smsSignature`)} dataIndex="sign" key="sign" ellipsis={true} />
          <Table.Column title={t(`marketingManagement.status`)} dataIndex="status" key="status" ellipsis={true} render={(text, record) => 
            <Tag  color={text===1 ? "success" : text===3 ? "error" : "blue" }>
              {text ? text===1 ? <CheckCircleOutlined /> : text===3 ? <CloseCircleOutlined /> :<ClockCircleOutlined /> : null}
              {' '}
              {statusList?.find(a=>parseInt(a?.code)===text)?.name}
            </Tag>
          } />
          {/* <Table.Column title={t(`marketingManagement.rejectReason`)} dataIndex="refuseReason" key="refuseReason" ellipsis={true}/> */}
          <Table.Column title={t(`marketingManagement.desc`)} dataIndex="description" key="description" ellipsis={true}/>
          <Table.Column title={t(`marketingManagement.createTime`)} dataIndex="createTime" key="createTime" ellipsis={true}/>
          <Table.Column title={t(`marketingManagement.default`)} dataIndex="isDefault" key="isDefault" ellipsis={true} render={(text, record) => 
            <Switch onChange={e => this.onChangeDefault(e,record)} defaultChecked={text===0} />
          } />
          <Table.Column title={t(`marketingManagement.usageRate`)} dataIndex="usageRate" key="usageRate" ellipsis={true}/>
          <Table.Column title={t(`marketingManagement.sendSum`)} dataIndex="transportVolume" key="transportVolume" ellipsis={true}/>
          <Table.Column width={100} align="center" fixed='right' title={t(`general.action`)} key="Action" render={(text, record) => (
            isPowerUser ? <>
              <Button type="link" onClick={() => this.handleDel(record)} icon={<DeleteOutlined/>} title={t(`general.delete`)}/>
            </> : null
          )}/>
        </Table>
      </>
    )
  }
}

export default withTranslation()(SearchResult)
